<div *ngIf="treatments" class="bulk-edit-wrapper">
    <loading-overlay *ngIf="loading"></loading-overlay>

    <bulk-edit-toolbar [logTag]="COMPONENT_LOG_TAG"
                       (exit)="exitClicked()"
                       [options]="bulkTemplates.bulkOptions"
                       [facet]="facet"
                       #bulkEditToolbar>
    </bulk-edit-toolbar>

    <div class="bulk-edit-grid">
        <bulk-edit-table [options]="bulkTemplates.bulkOptions"
                         [facet]="facet"
                         [itemsToEdit]="treatments"></bulk-edit-table>
    </div>
</div>
    
<treatment-plan-bulk-templates [isEdit]="true" [tasks]="treatments" #bulkTemplates></treatment-plan-bulk-templates>
